import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "indicator-load-monitoring" }
const _hoisted_2 = { class: "container-page big" }
const _hoisted_3 = {
  key: 0,
  class: "indicator-load-monitoring__download"
}
const _hoisted_4 = {
  key: 0,
  class: "indicator-load-monitoring__download-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_DownloadButton = _resolveComponent("DownloadButton")!
  const _component_TableWithOuterFilter = _resolveComponent("TableWithOuterFilter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, { title: "Мониторинг загрузки данных" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TableWithOuterFilter, {
        tableConfig: _ctx.getTableConfig,
        filtersConfig: _ctx.getFiltersConfig,
        selectButtonText: "Применить"
      }, {
        "filter-buttons": _withCtx(({ filter }) => [
          (_ctx.canExport)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_DownloadButton, {
                  loading: _ctx.isDownloading,
                  onClick: ($event: any) => (_ctx.onDownload(filter))
                }, null, 8, ["loading", "onClick"]),
                (_ctx.downloadMessage)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.downloadMessage), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["tableConfig", "filtersConfig"])
    ])
  ]))
}